// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"8a58cd01","83":"8329a0b2","182":"62126db0","284":"1bd6f28d","478":"b706c5b6","956":"579707d7"}[chunkId] + ".chunk.css";
};